import { createModuleApi } from '@wit-support/admin-client-core';
const api = createModuleApi({ errorFormat: 'raw' });
export function setChannelsApiBaseUrl(url) {
    api.setBaseUrl(url);
}
export async function listChannels() {
    const body = await api.get('/api/channels');
    return body.channels;
}
export async function createChannel(body) {
    return api.post('/api/channels', body);
}
export async function updateChannel(id, body) {
    return api.patch(`/api/channels/${id}`, body);
}
export async function deleteChannel(id) {
    const r = await api.del(`/api/channels/${id}`);
    if (!r.ok)
        throw new Error(`delete failed ${r.status}`);
}
export async function listSyncRuns(channelId) {
    const body = await api.get(`/api/channels/${channelId}/sync-runs`);
    return body.runs;
}
export async function startGoogleOAuth(body) {
    return api.post('/api/channels/google/start', body);
}
export async function reconnectGoogle(id) {
    return api.post(`/api/channels/${id}/google/reconnect`);
}
//# sourceMappingURL=api.js.map